var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12273_3357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.15625 7.73438C5.15625 3.55365 7.96785 1.55711 9.04543 0C8.33963 0.517807 0 2.54758 0 11C0 17.0418 4.95819 22 11 22C19.4514 22 21.472 13.6748 22 12.9552C20.5458 13.9613 18.4427 16.8438 14.2227 16.8438C9.24701 16.8438 5.15625 12.71 5.15625 7.73438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9287 3.39822L16.1561 0L14.4207 3.40326L10.5479 3.97293L13.3551 6.70078L12.7 10.6034L16.1561 8.7762L19.6728 10.5915L19.0051 6.69205L21.8035 3.95464L17.9287 3.39822Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12273_3357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA4);
export default __webpack_public_path__ + "static/media/a4.0a43b111d42937bce8e90b41841d6918.svg";
export { ForwardRef as ReactComponent };